const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
/* ─────────────────────────────────────────────────────────────────────────
   PHONE BOTTOM EDGE - real phones only, both orientations.

   The phone test matches html.pn-phone as stamped in layout/theme.liquid:
   coarse pointer with no hover AND the short side of the physical screen at
   most 600 CSS px. It is a property of the device, so it cannot change while
   the page is open - no media-query listener is needed, and turning the
   phone sideways keeps every behaviour here armed (the old max-width:779px
   test dropped it in landscape).

   Everything else about the phone shell is plain CSS in layout/theme.liquid.
   This block does the two things CSS cannot:

   The EDGE COLOUR IS NOT THIS SCRIPT'S JOB ANY MORE (2026-09-15). The canvas is
   painted #0a0a0a by server-rendered CSS and the wood rides on body, so wood shows
   behind the page, black shows below its last pixel, and the very first paint is
   already right - no beige, with or without JavaScript, however the page is
   restored. What is left here is cosmetic and safe to arrive late:

   1. Footer bleed. --pnfootbleed is how far the footer's black (a box-shadow, so
      no document height is added) runs past its own bottom edge. With a black
      canvas underneath it only has to swallow the fractional-pixel hairline at
      the join; black over black is invisible if it arrives late or not at all.

   2. theme-color, which older iOS uses for the status bar: the footer's #0a0a0a
      while the footer holds the bottom of the visual viewport, #E8BA8E otherwise.
      Pages too short to scroll are left alone. On iOS 26+ the top strip is
      sampled from the sticky header's own background instead, so this is a
      no-op there.

   On any non-phone nothing is listening and nothing is written. */
(function () {
  if (!window.matchMedia) return;
  var PHONE = false;
  try {
    PHONE = matchMedia('(hover: none) and (pointer: coarse)').matches &&
            !!window.screen && Math.min(screen.width, screen.height) <= 600;
  } catch (e) { PHONE = false; }
  var BLACK = '#0a0a0a';
  var D = document.documentElement;
  var pnf = null, meta = null, prior = null;
  var on = false, bleed = null, bound = false;

  /* The ROOT COLOUR IS NO LONGER WRITTEN FROM HERE (2026-09-15). The canvas is
     painted #0a0a0a in server-rendered CSS in layout/theme.liquid, so the edge is
     already correct on the very first paint - including a page restored at the
     footer, which used to show a beige band until this script's first sync. This
     function now only moves theme-color, which older iOS uses for the status bar;
     on iOS 26+ the top strip is sampled from the sticky header's own background. */
  function applyRoot(next) {
    if (next === on) return;
    on = next;
    if (meta) meta.setAttribute('content', next ? BLACK : (prior !== null ? prior : BLACK));
  }

  function setBleed(px) {
    if (px === bleed) return;
    bleed = px;
    if (px === null) D.style.removeProperty('--pnfootbleed');
    else D.style.setProperty('--pnfootbleed', px + 'px');
  }

  function sync() {
    if (!PHONE || !pnf) return;
    var vv = window.visualViewport;
    var vBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    var r = pnf.getBoundingClientRect();
    var below = Math.ceil(vBottom - r.bottom);
    var n = below > 0 ? below + 2 : 2;
    if (n > 400) n = 400;
    setBleed(n);
    var scrollable = D.scrollHeight > window.innerHeight + 40;
    applyRoot(scrollable && vBottom >= r.top + 24);
  }

  function onOrient() { setTimeout(sync, 250); }

  function bind() {
    if (bound) return;
    bound = true;
    addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    addEventListener('orientationchange', onOrient);
    if (window.visualViewport) {
      visualViewport.addEventListener('scroll', sync);
      visualViewport.addEventListener('resize', sync);
    }
    sync();
  }

  function unbind() {
    if (bound) {
      bound = false;
      removeEventListener('scroll', sync, { passive: true });
      removeEventListener('resize', sync);
      removeEventListener('orientationchange', onOrient);
      if (window.visualViewport) {
        visualViewport.removeEventListener('scroll', sync);
        visualViewport.removeEventListener('resize', sync);
      }
    }
    applyRoot(false);
    setBleed(null);
  }

  function boot() {
    pnf = document.querySelector('.pnf');
    meta = document.querySelector('meta[name="theme-color"]');
    prior = meta ? meta.getAttribute('content') : null;
    if (!pnf) return;
    if (PHONE) bind();
    /* the device class cannot change while the page is open, so there is
       nothing to listen for: a non-phone never binds, a phone stays bound
       through rotation (resize/orientationchange re-run sync above). */
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
